import { z } from 'zod';
import { createToolSignature, ToolSignature } from './tool-signature';

export const getLinkedinPostsLikesAndCommentsToolSignature = createToolSignature({
    name: 'getLinkedinPostsLikesAndCommentsTool',
    description: 'Get the comments and likes of a LinkedIn post.',
    inputSchema: z.object({
        postIds: z.array(z.string()).describe('An array of LinkedIn post IDs to get comments and likes for.'),
    }),
    outputSchema: z.array(
        z.object({
            postId: z.string().describe('The LinkedIn post ID that the comments are for.'),
            comments: z.array(
                z.object({
                    content: z.string().describe('The content of the comment.'),
                    commenterName: z.string().describe('The name of the commenter.'),
                    commenterHeadline: z.string().optional().describe('The headline of the commenter.'),
                    commenterMemberId: z.string().describe('The LinkedIn member ID of the commenter.'),
                }),
            ),
            likes: z.array(
                z.object({
                    name: z.string().describe('The name of the liker.'),
                    headline: z.string().optional().describe('The headline of the liker.'),
                    memberId: z.string().describe('The LinkedIn member ID of the liker.'),
                }),
            ),
        }),
    ),
    toolCallUi: (input) => `Getting comments for Linkedin post`,
});
